import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from '../../../app/store'
import fetchAPI from '../../../common/fetchAPI'
import { ExpenseEntryArchiveStateClass } from './interfaces/ExpenseEntryArchiveStateClass'
import { sortData } from '../../../common/timeLiveFunction'

const initialState: ExpenseEntryArchiveStateClass = {
    isLoading: false,
    status: 'idle',
    expenseEntryArchiveList: [],
    selectedRecord: {},
    isReload: false,
    currentPage: 1,
    // pageSize: 8,
    totalItems: 0,
    start: 0,
    // search: " ",
    recordsFiltered: 0,
    expenseEntryArchiveCheckedIds:[],
    isAllUnChecked:true,
    optionClientNameValue:"0",
    optionClientNameText:"All",
    optionEmployeeNameValue:"0",
    optionEmployeeNameText:"All",
    optionProjectValue:"0",
    optionProjectText:"All",
    optionProjectTaskValue:"0",
    optionProjectTaskText:"All",
    optionApprovedValue:"-1",
    optionApprovedText:"Both",
    startDate:new Date().toISOString(),
    endDate:new Date().toISOString(),
    includeDateRange:false,
    sortOrder: 'asc',
    sortColumn: 'EmployeeName',
    search: '',
    pageNo: 1,
    pageSize: 10

}
interface IThunkApi {
    state: {
        expenseEntryArchive: ExpenseEntryArchiveStateClass;
    },
}
export const getExpenseEntryArchiveForDatatableAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        'ExpenseEntryArchive/V2/getExpenseEntryArchiveForDatatable',
        async (arg, thunkApi) => {
            const { SearchParamsValues } = arg;  
            const response = await fetchAPI('api/V2/ExpenseEntryArchive/ExpenseEntryArchiveForDatatable/' + arg , 'Get', '', true, '0df3ab0c-4033-4013-8b1e-2f0b64f8cbab');
            const json = await response.json();
            return json;
        }
    )
    //UpdateTimeEntryArchive
export const updateExpenseEntryArchiveAsync = createAsyncThunk
<any, any, IThunkApi>
(
    'ExpenseEntryArchive/V2/UpdateExpenseEntryArchiveAsync',
    async (arg, thunkApi) => {
        //const {AccountLocationId} = arg;
        //const { AccountTaskTypeId, ...argWithoutId } = arg;
        const response = await fetchAPI('api/V2/ExpenseEntryArchive/UpdateExpenseEntryArchive', 'PUT', arg, true, '0df3ab0c-4033-4013-8b1e-2f0b64f8cbab');
        const json = await response.json();
        return json;
    }
)
export const deleteAccountEmployeeExpenseEntryAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        'ExpenseEntryArchive/V2/deleteAccountEmployeeExpenseEntry',
        async (arg, thunkApi) => {
            
            const response = await fetchAPI('api/V2/ExpenseEntryArchive/DeleteAccountEmployeeExpenseEntry', 'Delete', arg, true, '0df3ab0c-4033-4013-8b1e-2f0b64f8cbab');
            //const response = await fetchAPI('api/Logs/ApiRecord/3C6268F0-C22B-4BBC-9555-58BFD1DA6B27' , 'Get', '', true, '0df3ab0c-4033-4013-8b1e-2f0b64f8cbab');
            const json = await response.json();
            return json;
        }
    )

export const expenseEntryArchiveSlice = createSlice({
    name: 'expenseEntryArchive',
    initialState,
    reducers: {
        resetSelectedRecordObjectInState: (state) => {
            state.expenseEntryArchiveList = [];
            state.expenseEntryArchiveCheckedIds = [];
        },
        checkedState: (state, action) => {
            const currentindex = state.expenseEntryArchiveList.findIndex((item) => item.AccountEmployeeExpenseSheetId == action.payload);
            const newArray = [...state.expenseEntryArchiveList];
            newArray[currentindex] = { ...newArray[currentindex], isSelected: 1 };
            state.expenseEntryArchiveList = newArray;
            state.isAllUnChecked = false;
            //state.expenseEntryArchiveCheckedIds.push(newArray[currentindex].AccountEmployeeTimeEntryId);
            state.expenseEntryArchiveCheckedIds.push(newArray[currentindex]);
            
            
        },
        unCheckedState: (state, action) => {
            const currentindex = state.expenseEntryArchiveList.findIndex((item) => item.AccountEmployeeExpenseSheetId == action.payload);
            const newArray = [...state.expenseEntryArchiveList];
            newArray[currentindex] = { ...newArray[currentindex], isSelected: 0 };
            state.expenseEntryArchiveList = newArray;
            //state.expenseEntryArchiveCheckedIds = state.expenseEntryArchiveCheckedIds.filter(item => item !== newArray[currentindex].AccountEmployeeTimeEntryId);
            state.expenseEntryArchiveCheckedIds = state.expenseEntryArchiveCheckedIds.filter(item => item.AccountEmployeeExpenseSheetId !== newArray[currentindex].AccountEmployeeExpenseSheetId);
            
            
        },
        checkedAllState: (state) => {
            const newArray = state.expenseEntryArchiveList.map((item) => ({
                ...item,
                isSelected: 1,
            }));
            state.expenseEntryArchiveList = newArray;
            state.isAllUnChecked = false;
            state.expenseEntryArchiveList.map((i) => {
                if(!state.expenseEntryArchiveCheckedIds.includes(i))
                {
                    state.expenseEntryArchiveCheckedIds.push(i)
                }
                // if(!state.expenseEntryArchiveCheckedIds.includes(i.AccountEmployeeTimeEntryId))
                // {
                //     state.expenseEntryArchiveCheckedIds.push(i.AccountEmployeeTimeEntryId)
                // }
        });
        },
        unCheckedAllState: (state) => {
            const newArray = state.expenseEntryArchiveList.map((item) => ({
                ...item,
                isSelected: 0,
            }));
            state.expenseEntryArchiveList = newArray;
            state.isAllUnChecked = true;
            state.expenseEntryArchiveList.map((i) => (
                //state.expenseEntryArchiveCheckedIds = state.expenseEntryArchiveCheckedIds.filter(item => item !== i.AccountEmployeeTimeEntryId )
                state.expenseEntryArchiveCheckedIds = state.expenseEntryArchiveCheckedIds.filter(item => item.AccountEmployeeExpenseSheetId !== i.AccountEmployeeExpenseSheetId )
            ));
        },
        checkAllCheckboxIsUncheckedState: (state) => {
            state.isAllUnChecked = state.expenseEntryArchiveList.every((item) => item.isSelected === 0);
            
        },
        updatePagination: (state, action: PayloadAction<any>) => {
            state.pageSize = action.payload.pageSize;
            state.pageNo = action.payload.pageNo;
            state.search = action.payload.search;
        },
        updateSorting: (state, action) => {
            state.sortOrder = action.payload.sortOrder;
            state.sortColumn = action.payload.sortColumn;
            state.pageSize = action.payload.pageSize;
            state.pageNo = action.payload.pageNo;
            let tempArray = state.expenseEntryArchiveList;
            state.expenseEntryArchiveList = sortData(tempArray, action.payload.sortOrder, action.payload.sortColumn);
        },
        Edit: (state, action) => {
            state.selectedRecord = action.payload;
        },
        setOptionClientNameValue: (state, action) => {
            const {value,label} = action.payload;
            state.optionClientNameValue = value;
            state.optionClientNameText = label;
        },
        setOptionEmployeeNameValue: (state, action) => {
            const {value,label} = action.payload;
            state.optionEmployeeNameValue = value;
            state.optionEmployeeNameText = label;
        },
        setOptionProjectValue: (state, action) => {
            const {value,label} = action.payload;
            state.optionProjectValue = value;
            state.optionProjectText = label;
        },
        setOptionProjectTaskValue: (state, action) => {
            const {value,label} = action.payload;
            state.optionProjectTaskValue = value;
            state.optionProjectTaskText = label;
        },
        setOptionApprovedValue: (state, action) => {
            const {value,label} = action.payload;
            state.optionApprovedValue = value;
            state.optionApprovedText = label;
        },
        setDateRangeValue: (state, action) => {
           const {startDate,endDate} = action.payload;
            state.startDate = startDate;
            state.endDate = endDate;
        },
        setIncludeDateRangeValue: (state, action) => {
             state.includeDateRange = action.payload;
         },
        resetExpensearchiveFilters: (state) => {
            state.optionEmployeeNameValue = "0";
            state.optionApprovedValue = "-1";
            state.includeDateRange = false;
            state.startDate = new Date().toISOString();
            state.endDate = new Date().toISOString();
            state.search = "";
            state.pageNo = 1;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getExpenseEntryArchiveForDatatableAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = false;

            })
            .addCase(getExpenseEntryArchiveForDatatableAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isLoading = false;
           
                if (payload.Data !== undefined) {
                    state.expenseEntryArchiveList = payload.Data;
                    state.expenseEntryArchiveList.map((item: any) => {
                        item.isSelected = 0;
                 });
                    state.isReload = false;
                    state.selectedRecord = {}; 
                }

            })
            .addCase(getExpenseEntryArchiveForDatatableAsync.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;

            })

            .addCase(deleteAccountEmployeeExpenseEntryAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;

            })
            .addCase(deleteAccountEmployeeExpenseEntryAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isReload = true;
                state.isLoading = false;
                state.expenseEntryArchiveCheckedIds = [];
                
                
            })
            .addCase(deleteAccountEmployeeExpenseEntryAsync.rejected, (state) => {
                state.status = 'failed'
                state.isLoading = false;
                ;
            })

            .addCase(updateExpenseEntryArchiveAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;

            })
            .addCase(updateExpenseEntryArchiveAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isLoading = false;

                state.isReload = true;
            })
            .addCase(updateExpenseEntryArchiveAsync.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;

            })

    }
})

export const {
    resetSelectedRecordObjectInState, checkedState, unCheckedState, checkedAllState, unCheckedAllState, checkAllCheckboxIsUncheckedState,updatePagination,updateSorting,Edit,
    setOptionApprovedValue,setOptionClientNameValue,setOptionEmployeeNameValue,setOptionProjectTaskValue,setOptionProjectValue,setDateRangeValue,setIncludeDateRangeValue, resetExpensearchiveFilters
} = expenseEntryArchiveSlice.actions
export const ExpenseEntryArchiveState = (state: RootState) => state.expenseEntryArchive
export default expenseEntryArchiveSlice.reducer
